/**
 * OneTrust consent for A/B testing. Both the `ab_bucket` cookie (persistBucket.ts) and the experiment exposure
 * (AbExposure) are gated on the same category, so an exposure is only sent for a visitor whose bucket is stored.
 */
import { env } from '@zopauk/nextjs-env';

declare global {
  interface Window {
    // OneTrust: comma-separated consented categories, e.g. ',C0001,C0002,' (undefined until OneTrust loads)
    OnetrustActiveGroups?: string;
  }
}

// Provisional default: the OneTrust category A/B testing belongs to. Confirm with the cookie-policy owner
// (the cookies standard lists C0002 as Performance). Overridable with NEXT_PUBLIC_ONETRUST_AB_GROUP, so it can
// follow the OneTrust config without a code change (same pattern as signup-web's ONETRUST_TARGETING_GROUP).
export const DEFAULT_AB_CONSENT_CATEGORY = 'C0002';

export const getAbConsentCategory = (): string => env('NEXT_PUBLIC_ONETRUST_AB_GROUP') || DEFAULT_AB_CONSENT_CATEGORY;

// OneTrust dispatches this when it loads and whenever the visitor changes their consent.
export const CONSENT_EVENT = 'OneTrustGroupsUpdated';

// `undefined` = OneTrust hasn't loaded yet; its CONSENT_EVENT follows once it has.
export function hasAbConsent(): undefined | boolean {
  const groups = window.OnetrustActiveGroups;
  return groups === undefined ? undefined : groups.split(',').includes(getAbConsentCategory());
}
